<template>
  <div :class="containerClass">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'Layout',
  async mounted () {
  },
  data() {
    return {
      containerClass: 'front-page'
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
  body{font-family: 'Roboto'; font-size: 12px;
    .front-page{overflow: hidden;}
  }
</style>
